export const buildUpiUrl = ({ upiId, name, amount, note }) => {
  const params = [
    `pa=${upiId}`,
    `pn=${encodeURIComponent(name)}`,
    `am=${amount.toFixed(2)}`,
    `cu=INR`,
    `tn=${encodeURIComponent(note || "Bloom Store")}`,
  ].join("&");
  return `upi://pay?${params}`;
};

export const buildQrUrl = (u) => `https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(u)}&size=200x200&margin=12&color=2D1F2B&bgcolor=FFFFFF`;
export const isValidUpi  = (id) => /^[\w.\-_]{2,256}@[a-zA-Z]{2,64}$/.test(id||"");

export const UPI_APPS = [
  { name:"PhonePe", mark:"Pe", url: u => u.replace("upi://","phonepe://") },
  { name:"GPay",    mark:"G", url: u => u.replace("upi://pay?","tez://upi/pay?") },
  { name:"Paytm",   mark:"Pt", url: u => u.replace("upi://","paytmmp://") },
  { name:"BHIM",    mark:"B", url: u => u },
  { name:"Any UPI", mark:"UPI", url: u => u },
];
